import {
  SingleProviderConfig,
  ShopType,
  CheckoutType,
  CrossSellType,
} from 'types';
import { asyncEligible, getDefaultCrossSellAction } from 'config';
import {
  ATT,
  Brightspeed,
  BrightspeedV2,
  CenturyLink,
  QuantumFiber,
  Frontier,
  Windstream,
  CincinnatiBell,
  Verizon,
  //Earthlink,
} from 'config/providers';
import { ATTTheme } from 'config/themes';

export const ATTSpecial: SingleProviderConfig = {
  name: 'ATTSpecial',
  micrositeCode: 'ATT',
  mainProvider: ATT,
  shopType: ShopType.SINGLE_PROVIDER,
  // shopType: ShopType.SYNTHETIC,
  domain: 'attspecial.com',
  homepage: 'https://attspecial.com',
  title: 'AT&T Authorized Dealer',
  fallbackPhoneNumber: '866-878-7382',
  fallbackLeadModePhoneNumber: '866-428-5671',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: ATTTheme,
  needsDcSession: false,
  source: 'ATT',
  noOffersRetry: 2,
  getCrossSellAction: getDefaultCrossSellAction,
  getCheckoutType: asyncEligible,
  updaterCrossSellActive: false,
  crossSellProviders: [
    Verizon,
    Brightspeed,
    BrightspeedV2,
    CenturyLink,
    QuantumFiber,
    Frontier,
    Windstream,
    CincinnatiBell,
    //Earthlink,
  ],
  movingAppBuyflowUrls: {
    development: 'http://localhost:3000/guest/tvi/buy',
    staging: 'https://staging-cart.attspecial.com/guest/tvi/buy',
    qa: 'https://staging-cart.attspecial.com/guest/tvi/buy',
    production: 'https://cart.attspecial.com/guest/tvi/buy',
  },
};
